import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { DataGrid as MuiDataGrid } from '@mui/x-data-grid';

import { withDefaultRenderCell } from 'helpers/dataGrid';
import { DataGridFooter } from './DataGridFooter';
import s from './styled';

const DataGrid = memo(function DataGrid(props) {
  const { total, ...rest } = props;
  const rootProps = {
    slots: {
      footer: DataGridFooter,
      ...rest?.slots,
    },
    slotProps: {
      ...rest?.slotsProps,
      footer: {
        total,
        ...rest?.slotsProps?.footer,
      },
    },
    ...rest,
  };

  rootProps.columns = withDefaultRenderCell(rootProps.columns);

  return <s.DataGrid {...rootProps} />;
});

DataGrid.propTypes = {
  rows: PropTypes.array,
  columns: PropTypes.array,
  total: PropTypes.object,
  pageSize: PropTypes.number,
  ...MuiDataGrid.propTypes,
};

export default DataGrid;
